
import { getMyRosters } from "@/common/js/api.js";
import Badge from 'vux/src/components/badge/index.vue'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Box from 'vux/src/components/box/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Group from 'vux/src/components/group/index.vue'
import CellBox from 'vux/src/components/cell-box/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Scroller from 'vux/src/components/scroller/index.vue'
import Icon from 'vux/src/components/icon/index.vue'
import Sticky from 'vux/src/components/sticky/index.vue'


export default {
components: {
Badge,
Tab,
TabItem,
XHeader,
Box,
XButton,
Group,
CellBox,
Cell,
Scroller,
Icon,
Sticky
},
methods: {
getList() {
let self = this;
getMyRosters({ data: this.pageInfo }).then(function(data) {
self.view.firstLoad = false;
if (data.PageIndex > 1) {
self.list = self.list.concat(data.Content);
} else {
self.list = data.Content;
}
self.view.loading = false;
});
}
},
mounted() {
console.log("mounted");
this.getList();
},
activated() {

console.log("activated");

},
data() {
return {
view: {
loading: true,
firstLoad: true
},
status: {
pullupStatus: "default",
pulldownStatus: "default"
},
pageInfo: {
pageIndex: 1,
pageSize: 10,
keyword: "",
extInfo: undefined
},
title: "我的消息",
disabled:
typeof navigator !== "undefined" &&
/iphone/i.test(navigator.userAgent) &&
/ucbrowser/i.test(navigator.userAgent),
list: []
};
}
};



// WEBPACK FOOTER //
// ./src/components/chat/roster.vue